(() => {
  'use strict';
  if (window.WBGlacier) return;
  window.WBGlacier = true;
  const root = document.getElementById('wb-page');
  if (!root) return;
  const readData = () => JSON.parse(document.querySelector('[data-wb-product]').textContent);
  let data = readData(), selected, quantity = 1, cart = null, lock = false, galleryIndex = 0;
  const $ = s => document.querySelector(s), $$ = s => [...document.querySelectorAll(s)];
  const prefix = window.Shopify?.routes?.root || '/';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: data.currency}).format(cents / 100);
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const icons = {
    trash: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h18M9 6V3h6v3M6 6l1 15h10l1-15M10 10v7M14 10v7"/></svg>',
    minus: '−', plus: '+'
  };
  const create = (tag, cls, text) => {
    const node = document.createElement(tag); if (cls) node.className = cls;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const announce = message => { $('[data-wb-message]').textContent = message; };
  const variant = () => data.variants.find(v => String(v.id) === String(selected)) || data.variants[0];
  const maxQuantity = v => v.inventory_management && v.inventory_policy !== 'continue' ? Math.max(0, v.inventory_quantity) : 999999;
  const clampQuantity = (value, v = variant()) => Math.min(Math.max(1, Math.floor(Number(value) || 1)), Math.max(1, maxQuantity(v)));
  async function request(endpoint, options = {}) {
    const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 18000);
    try {
      const res = await fetch(prefix + endpoint, {...options, credentials:'same-origin', signal:controller.signal, headers:{'Content-Type':'application/json', 'Accept':'application/json', ...options.headers}});
      const json = await res.json();
      if (!res.ok) throw Error(json.description || json.message || 'Please try again.');
      return json;
    } catch (error) {
      if (error.name === 'AbortError') throw Error('The request took too long. Check your cart before trying again.');
      throw error;
    } finally { clearTimeout(timer); }
  }
  function setBusy(button, busy, showSpinner = true) {
    if (!button) return;
    button.classList.toggle('wb-busy', busy && showSpinner);
    button.setAttribute('aria-busy', String(busy));
    button.disabled = busy;
  }
  function refreshPaymentButtons() {
    $$('[data-wb-payment-badge]').forEach(badge => {
      const fn = badge.dataset.wbPaymentBadge === 'paypal' ? 'itcCartDrawerPayPal' : 'itcCartDrawerCheckout';
      badge.hidden = typeof window[fn] !== 'function';
    });
    $$('[data-wb-payment]').forEach(button => {
      const fn = button.dataset.wbPayment === 'paypal' ? 'itcCartDrawerPayPal' : 'itcCartDrawerCheckout';
      button.hidden = typeof window[fn] !== 'function';
      if (!button.classList.contains('wb-busy')) button.disabled = button.closest('#wb-cart') ? !cart?.item_count : !variant().available;
    });
  }
  function updateSelection(id, writeUrl = false) {
    selected = String(id);
    const v = variant(); quantity = clampQuantity(quantity, v);
    $$('[data-wb-variant]').forEach(b => {
      const chosen = b.dataset.wbVariant === String(v.id);
      b.classList.toggle('chosen', chosen); b.setAttribute('aria-pressed', String(chosen));
    });
    $$('[data-wb-title]').forEach(e => e.textContent = data.displayTitle);
    $$('[data-wb-color]').forEach(e => e.textContent = v.title);
    $$('[data-wb-price]').forEach(e => e.textContent = money(v.price));
    $$('[data-wb-total]').forEach(e => e.textContent = money(v.price * quantity));
    $$('[data-wb-compare]').forEach(e => {e.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; e.hidden = !(v.compare_at_price > v.price);});
    $$('[data-wb-selected-image]').forEach(e => {e.src = v.image; e.alt = v.title + ' winter balaclava';});
    $$('[data-wb-quantity]').forEach(e => {e.value = quantity; e.max = maxQuantity(v);});
    $$('[data-wb-add]').forEach(e => {
      if (!e.classList.contains('wb-busy')) e.disabled = !v.available;
      const text = e.querySelector('[data-button-label]');
      if (text) text.textContent = v.available ? 'ADD TO CART' : 'SOLD OUT';
    });
    $$('[data-wb-native-id]').forEach(e => e.value = v.id);
    $$('[data-wb-native-quantity]').forEach(e => e.value = quantity);
    galleryIndex = data.gallery.findIndex(item => item.src === v.image); showGallery(Math.max(0, galleryIndex));
    refreshPaymentButtons();
    if (writeUrl) { const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url); }
  }
  function showGallery(index) {
    galleryIndex = (index + data.gallery.length) % data.gallery.length;
    const item = data.gallery[galleryIndex], main = $('[data-wb-gallery]');
    if (!main || !item) return;
    main.src = item.src; main.alt = item.alt;
    $$('[data-wb-thumb]').forEach((b, i) => {b.classList.toggle('chosen', i === galleryIndex); b.setAttribute('aria-current', String(i === galleryIndex));});
    $('[data-wb-gallery-counter]').textContent = `${galleryIndex + 1} / ${data.gallery.length}`;
  }
  let returnFocus = null;
  function openDialog(dialog, source) {
    returnFocus = source || document.activeElement;
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('wb-dialog-open');
  }
  function closeDialog(dialog) {
    dialog.close(); document.documentElement.classList.remove('wb-dialog-open');
    returnFocus?.focus({preventScroll:true});
  }
  $$('dialog.wb-dialog').forEach(dialog => {
    dialog.addEventListener('close', () => document.documentElement.classList.remove('wb-dialog-open'));
    dialog.addEventListener('cancel', () => {document.documentElement.classList.remove('wb-dialog-open'); returnFocus?.focus({preventScroll:true});});
    dialog.addEventListener('click', e => {if(e.target === dialog) closeDialog(dialog);});
  });
  function renderCart(result) {
    cart = result; const list = $('[data-wb-cart-lines]'); list.replaceChildren();
    $$('[data-wb-cart-count]').forEach(e => e.textContent = result.item_count);
    $('[data-wb-cart-subtotal]').textContent = new Intl.NumberFormat('en', {style:'currency',currency:result.currency}).format(result.total_price / 100);
    $('[data-wb-cart-error]').textContent = '';
    $('[data-wb-cart-refresh]').hidden = true;
    if (!result.items.length) list.append(create('p', 'wb-empty', 'Your cart is empty.'));
    result.items.forEach(item => {
      const row = create('article','wb-cart-row'); row.dataset.key = item.key;
      const own = data.variants.find(v => Number(v.id) === item.variant_id);
      const photo = create('img'); photo.src = own?.image || item.featured_image?.url || item.image || ''; photo.alt = item.product_title; photo.loading = 'lazy';
      if (!photo.src || photo.src === location.href) photo.hidden = true;
      const body = create('div','wb-cart-row-body'), title = create('a','wb-cart-title',item.product_title);
      title.href = item.url; body.append(title);
      if (item.variant_title && item.variant_title !== 'Default Title') body.append(create('p','wb-cart-option', item.variant_title));
      Object.entries(item.properties || {}).filter(([k,v]) => !k.startsWith('_') && v).forEach(([k,v]) => body.append(create('p','wb-cart-property', `${k}: ${v}`)));
      if(item.selling_plan_allocation?.selling_plan?.name) body.append(create('p','wb-cart-option',item.selling_plan_allocation.selling_plan.name));
      const fmt = n => new Intl.NumberFormat('en',{style:'currency',currency:result.currency}).format(n / 100);
      body.append(create('p','wb-cart-unit', `${fmt(item.final_price)} each`));
      const controls = create('div','wb-cart-quantity');
      for (const [action,label] of [['minus','Decrease quantity'],['input','Quantity'],['plus','Increase quantity'],['delete','Delete item']]) {
        const control = create(action === 'input' ? 'input' : 'button');
        control.dataset.cartAction = action; control.dataset.lineKey = item.key;
        control.setAttribute('aria-label', `${label}: ${item.product_title}, ${item.variant_title || ''}`);
        if (action === 'input') {control.type = 'number'; control.min = '1'; control.step = '1'; control.value = item.quantity;}
        else {control.type = 'button'; control.innerHTML = action === 'delete' ? icons.trash : icons[action]; if(action === 'minus') control.disabled = item.quantity <= 1;}
        controls.append(control);
      }
      body.append(controls); row.append(photo,body,create('strong','wb-cart-line-price', fmt(item.final_line_price))); list.append(row);
    });
    refreshPaymentButtons();
  }
  async function readCart(message = '') {
    try {renderCart(await request('cart.js')); if(message) $('[data-wb-cart-error]').textContent = message;}
    catch(error) {
      cart = null; $('[data-wb-cart-lines]').replaceChildren();
      $('[data-wb-cart-subtotal]').textContent = '—';
      $('[data-wb-cart-error]').textContent = message || 'Cart details could not load. Refresh the cart to see your items.';
      $('[data-wb-cart-refresh]').hidden = false; refreshPaymentButtons();
      throw error;
    }
  }
  async function add(button, payment) {
    if (lock || !variant().available) return;
    lock = true; setBusy(button, true); announce('');
    let added = false;
    try {
      await request('cart/add.js', {method:'POST', body:JSON.stringify({items:[{id:variant().id,quantity}]})}); added = true;
      await readCart();
      if (payment) {handoffPayment(button,payment); return;}
      openDialog($('#wb-cart'),button); announce('Added to your cart.');
    } catch(error) {
      if (added) {
        openDialog($('#wb-cart'),button);
        $('[data-wb-cart-error]').textContent = 'Added to your cart, but the cart details could not load. Refresh the cart; do not add again.';
        $('[data-wb-cart-refresh]').hidden = false;
      } else {announce(error.message); if(/too long/.test(error.message)){openDialog($('#wb-cart'),button);readCart('Check whether your item was added before trying again.').catch(()=>{});}}
    } finally {if (!payment || !added || !button.classList.contains('wb-handoff')) {lock = false; setBusy(button,false);}}
  }
  function handoffPayment(button, type) {
    const name = type === 'paypal' ? 'itcCartDrawerPayPal' : 'itcCartDrawerCheckout';
    if(typeof window[name] !== 'function') {lock=false;setBusy(button,false);announce('This payment option is temporarily unavailable.');return;}
    button.classList.add('wb-handoff'); setBusy(button,true); lock=true;
    try {
      window[name]({currentTarget:button,target:button,preventDefault(){},stopPropagation(){}});
      setTimeout(() => {
        if(button.isConnected) {
          button.classList.remove('wb-handoff'); setBusy(button,false); lock=false;
          announce('If checkout did not open, you can retry from the cart. Your items remain in the cart.');
        }
      },22000);
    } catch(error) {button.classList.remove('wb-handoff');setBusy(button,false);lock=false;announce('Checkout could not open. Please try again from your cart.');}
  }
  async function changeCart(key, value, button) {
    if (lock || !cart) return;
    const row = cart.items.find(i => i.key === key); if(!row) return;
    if(!Number.isInteger(value) || value < 0) {renderCart(cart); $('[data-wb-cart-error]').textContent = 'Enter a whole number of 1 or more. Use the trash button to delete.';return;}
    const showSpinner = !['plus','minus'].includes(button?.dataset.cartAction);
    lock=true;setBusy(button,true,showSpinner);
    const old=cart;
    try {renderCart(await request('cart/change.js',{method:'POST',body:JSON.stringify({id:key,quantity:value})}));}
    catch(error) {renderCart(old);$('[data-wb-cart-error]').textContent=error.message;}
    finally {lock=false;setBusy(button,false);}
  }
  document.addEventListener('click', e => {
    const b=e.target.closest('button,a'); if(!b)return;
    if(b.dataset.wbVariant){e.preventDefault();updateSelection(b.dataset.wbVariant,true);}
    else if(b.hasAttribute('data-wb-add')){e.preventDefault();add(b);}
    else if(b.hasAttribute('data-wb-qty-step')){quantity=clampQuantity(quantity+Number(b.dataset.wbQtyStep));updateSelection(selected);}
    else if(b.hasAttribute('data-wb-thumb')) showGallery(Number(b.dataset.wbThumb));
    else if(b.hasAttribute('data-wb-gallery-step')) showGallery(galleryIndex+Number(b.dataset.wbGalleryStep));
    else if(b.hasAttribute('data-wb-zoom')) {const image=$('#wb-lightbox img');image.src=$('[data-wb-gallery]').src;image.alt=$('[data-wb-gallery]').alt;image.style.transform='scale(1)';$('#wb-lightbox input').value=1;openDialog($('#wb-lightbox'),b);}
    else if(b.hasAttribute('data-wb-cart-open')){e.preventDefault();openDialog($('#wb-cart'),b);readCart().catch(()=>{});}
    else if(b.hasAttribute('data-wb-close')) closeDialog(b.closest('dialog'));
    else if(b.hasAttribute('data-wb-cart-refresh')) readCart().catch(()=>{});
    else if(b.dataset.wbPayment){e.preventDefault();if(lock)return;if(b.closest('#wb-cart')){if(cart?.item_count)handoffPayment(b,b.dataset.wbPayment);}else add(b,b.dataset.wbPayment);}
    else if(b.dataset.cartAction){const item=cart?.items.find(i=>i.key===b.dataset.lineKey);if(!item)return;const action=b.dataset.cartAction;changeCart(item.key,action==='delete'?0:item.quantity+(action==='plus'?1:-1),b);}
    else if(b.hasAttribute('data-wb-top')){window.scrollTo({top:0,behavior:reduced()?'instant':'smooth'});$('#wb-nav').focus({preventScroll:true});}
    else if(b.dataset.wbSocial){e.preventDefault();openShare(b.dataset.wbSocial,b);}
    else if(b.hasAttribute('data-wb-copy')) copyLink();
    else if(b.matches('[data-wb-tab]')) activateTab(b.closest('[data-wb-tabs]'),Number(b.dataset.wbTab));
  });
  document.addEventListener('change', e => {
    if(e.target.matches('[data-wb-quantity]')) {quantity=clampQuantity(e.target.value);updateSelection(selected);}
    if(e.target.dataset.cartAction==='input'){const v=Number(e.target.value);if(!Number.isInteger(v)||v<1){renderCart(cart);$('[data-wb-cart-error]').textContent='Enter a whole number of 1 or more.';}else changeCart(e.target.dataset.lineKey,v,e.target);}
  });
  document.addEventListener('submit',e=>{if(e.target.matches('[data-wb-product-form]')){e.preventDefault();add(e.submitter||e.target.querySelector('[data-wb-add]'));}});
  const gallery=$('[data-wb-gallery]');let start;
  gallery?.addEventListener('touchstart',e=>{start={x:e.changedTouches[0].clientX,y:e.changedTouches[0].clientY};},{passive:true});
  gallery?.addEventListener('touchend',e=>{if(!start)return;const dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.4)showGallery(galleryIndex+(dx<0?1:-1));start=null;},{passive:true});
  $('#wb-lightbox input')?.addEventListener('input',e=>$('#wb-lightbox img').style.transform=`scale(${e.target.value})`);
  function activateTab(container,index) {
    const buttons=[...container.querySelectorAll('[data-wb-tab]')],panels=[...container.querySelectorAll('[data-wb-panel]')];
    buttons.forEach((b,i)=>{b.classList.toggle('active',i===index);b.setAttribute('aria-selected',String(i===index));b.tabIndex=i===index?0:-1;});
    panels.forEach((p,i)=>p.hidden=i!==index);
  }
  const motionPreference=matchMedia('(prefers-reduced-motion: reduce)');
  function setDemoState(img,paused){
    img.dataset.wbMotionSource ||= img.src;
    img.src=paused?img.dataset.wbPoster:img.dataset.wbMotionSource;
    const button=img.nextElementSibling;button.setAttribute('aria-pressed',String(paused));button.textContent=paused?'Play demonstration':'Pause demonstration';
  }
  $$('[data-wb-demo]').forEach(img=>{
    setDemoState(img,reduced());
    img.nextElementSibling.addEventListener('click',()=>setDemoState(img,img.nextElementSibling.getAttribute('aria-pressed')!=='true'));
  });
  motionPreference.addEventListener('change',()=>$$('[data-wb-demo]').forEach(img=>setDemoState(img,reduced())));
  $$('[data-wb-tabs]').forEach(container=>{
    activateTab(container,0);
    container.addEventListener('keydown',e=>{const buttons=[...container.querySelectorAll('[data-wb-tab]')],index=buttons.indexOf(e.target);if(index<0)return;let next;if(e.key==='ArrowRight')next=(index+1)%buttons.length;if(e.key==='ArrowLeft')next=(index+buttons.length-1)%buttons.length;if(e.key==='Home')next=0;if(e.key==='End')next=buttons.length-1;if(next!==undefined){e.preventDefault();activateTab(container,next);buttons[next].focus();}});
  });
  $$('.slider input').forEach(input=>{
    const update=()=>{const slider=input.closest('.slider');slider.querySelector('.overlay').style.clipPath=`inset(0 ${100-Number(input.value)}% 0 0)`;slider.querySelector('.divider').style.left=input.value+'%';};
    input.addEventListener('input',update);input.setAttribute('aria-label','Adjust coverage comparison');update();
  });
  function setupMarquee(element) {
    const group=element.querySelector('.wb-marquee-group');if(!group)return;
    const original=group.innerHTML; const width=group.getBoundingClientRect().width;
    if(width<1)return;
    element.querySelectorAll('[data-clone]').forEach(e=>e.remove());
    for(let i=0;i<Math.ceil(innerWidth/width)+1;i++){const clone=group.cloneNode(true);clone.dataset.clone='';clone.setAttribute('aria-hidden','true');element.querySelector('.wb-marquee-track').append(clone);}
    element.style.setProperty('--marquee-width',width+'px');element.style.setProperty('--marquee-time',Math.max(20,width/35)+'s');
  }
  $$('.wb-marquee').forEach(setupMarquee);
  let resizeTimer;window.addEventListener('resize',()=>{clearTimeout(resizeTimer);resizeTimer=setTimeout(()=>$$('.wb-marquee').forEach(setupMarquee),160);});
  document.fonts?.ready.then(()=>$$('.wb-marquee').forEach(setupMarquee));
  $$('[data-wb-carousel]').forEach(carousel=>{
    const track=carousel.querySelector('.wb-carousel-track');let paused=false,index=0,timer;
    const cards=[...track.children];cards.slice(0,4).forEach(c=>{const copy=c.cloneNode(true);copy.setAttribute('aria-hidden','true');copy.dataset.clone='';track.append(copy);});
    const move=()=>{
      if(paused||document.hidden||reduced()){timer=setTimeout(move,1000);return;}
      const width=cards[0].getBoundingClientRect().width+20;index++;
      track.style.transition='transform 500ms ease';track.style.transform=`translateX(${-width*index}px)`;
      timer=setTimeout(()=>{if(index===cards.length){index=0;track.style.transition='none';track.style.transform='translateX(0)';}timer=setTimeout(move,5000);},520);
    };
    carousel.addEventListener('mouseenter',()=>paused=true);carousel.addEventListener('mouseleave',()=>paused=false);
    carousel.addEventListener('focusin',()=>paused=true);
    carousel.addEventListener('focusout',e=>{if(!carousel.contains(e.relatedTarget))paused=false;});
    carousel.addEventListener('keydown',e=>{if(e.key==='Escape'){paused=true;}});
    timer=setTimeout(move,5000);
  });
  const platforms={Instagram:{url:'https://www.instagram.com/',next:'Copy this link, then paste it into a message or a Story link sticker after signing in.'},YouTube:{url:'https://www.youtube.com/',next:'Copy this link, then use Create → Create post if your channel supports posts.'},TikTok:{url:'https://www.tiktok.com/upload',next:'Copy this link, choose your own video and paste the link where your account permits it.'}};
  function openShare(platform,button){const p=platforms[platform];if(!p)return;$('#wb-share-title').textContent=platform;$('#wb-share-link').value=data.canonical;$('#wb-share-next').textContent=p.next;$('#wb-share-platform').href=p.url;$('#wb-share-status').textContent='';openDialog($('#wb-share'),button);}
  async function copyLink(){const field=$('#wb-share-link');try{if(!navigator.clipboard)throw Error();await navigator.clipboard.writeText(field.value);$('#wb-share-status').textContent='Link copied.';}catch{field.focus();field.select();let copied=false;try{copied=document.execCommand('copy');}catch{}$('#wb-share-status').textContent=copied?'Link copied.':'Select and copy the link above manually.';}}
  const sticky=$('.wb-sticky'),top=$('[data-wb-top]');
  if(sticky)new ResizeObserver(()=>document.documentElement.style.setProperty('--wb-sticky-height',sticky.getBoundingClientRect().height+'px')).observe(sticky);
  const onScroll=()=>{top.hidden=scrollY<500;};addEventListener('scroll',onScroll,{passive:true});onScroll();
  addEventListener('pageshow',()=>{lock=false;$$('.wb-busy').forEach(b=>{b.classList.remove('wb-handoff');setBusy(b,false);});refreshPaymentButtons();});
  let paymentAttempts=0;const paymentTimer=setInterval(()=>{refreshPaymentButtons();if(++paymentAttempts>30)clearInterval(paymentTimer);},1000);
  updateSelection(new URL(location.href).searchParams.get('variant')||data.selected);
  // Event handlers are delegated. Shopify's theme editor reloads sections without a full page reload.
  document.addEventListener('shopify:section:load',()=>{data=readData();updateSelection(selected);$$('.wb-marquee').forEach(setupMarquee);});
})();
